"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var memoize = require("fast-memoize");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var translate_1 = require("utils/translate");
var ssoActions = require("@caddigital/sok-reducers/lib/actions/sso");
var sok_ui_1 = require("@caddigital/sok-ui");
var components_1 = require("components");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var avatars_1 = require("components/Avatar/avatars");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var Types = require("types");
var text_1 = require("utils/text");
require("./styles.scss");
var headers = ['id', 'name'];
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        selectedLanguage: selectedLanguage,
        management: state.sso.management
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetchClients: function () { return dispatch(ssoActions.fetchManagementClientListRequest()); },
    fetch: function () { return dispatch(ssoActions.fetchManagementListRequest()); },
    clearManagementModals: function () { return dispatch(ssoActions.clearManagementModals()); },
    create: function (sso) {
        return dispatch(ssoActions.createNewFederationRequest(sso));
    },
    remove: function (sso) { return dispatch(ssoActions.managementRemoveRequest(sso)); },
    select: function (sso, select) {
        return dispatch(ssoActions.managementListSelect(sso, select));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var initialState = {
    visible: false,
    policy: 'SINGLE',
    provider: '',
    clientId: '',
    name: ''
};
var createModalEnhance = (0, recompose_1.compose)((0, recompose_1.withState)('state', 'setState', __assign({}, initialState)), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if (this.props.createStatus !== prevProps.createStatus &&
            this.props.createStatus === 'FETCHED') {
            this.props.setState(__assign({}, initialState));
            this.props.setIsOpen(false);
            this.props.fetch();
        }
        if (!this.props.isOpen && prevProps.isOpen) {
            this.props.clearManagementModals();
        }
    }
}), recompose_1.pure);
var CreateFederation = createModalEnhance(function (props) {
    return (React.createElement(sok_ui_1.Modal, { isOpen: props.isOpen, className: 'sso-management-create-federation' },
        React.createElement(sok_ui_1.Header, { onClose: function () { return props.setIsOpen(false); } }, (0, translation_1.getLocalization)('sso/management/create/header')),
        React.createElement(sok_ui_1.Container, null,
            React.createElement(sok_ui_1.RequestStatusBox, { status: props.createStatus, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILURE'] },
                React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/creating')),
                React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/created')),
                React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/failed'))),
            React.createElement("table", null,
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("label", null,
                            (0, translation_1.getLocalization)("sso/management/settings/name"),
                            ":")),
                    React.createElement("td", null,
                        React.createElement("span", null,
                            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("sso/management/settings/name/tooltip")) },
                                React.createElement(components_1.TableRowIcon, { className: 'black', icon: 'fa-info', circle: true })))),
                    React.createElement("td", null,
                        React.createElement(sok_ui_1.TextInput, { value: props.state.name, onChange: function (e) {
                                return props.setState(__assign(__assign({}, props.state), { name: e.target.value }));
                            } }))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("label", null,
                            (0, translation_1.getLocalization)("sso/management/settings/provider"),
                            ":")),
                    React.createElement("td", null,
                        React.createElement("span", null,
                            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("sso/management/settings/provider/tooltip")) },
                                React.createElement(components_1.TableRowIcon, { className: 'black', icon: 'fa-info', circle: true })))),
                    React.createElement("td", null,
                        React.createElement(sok_ui_1.TextInput, { value: props.state.provider, onChange: function (e) {
                                return props.setState(__assign(__assign({}, props.state), { provider: e.target.value }));
                            } }))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("label", null,
                            (0, translation_1.getLocalization)("sso/management/settings/client"),
                            ":")),
                    React.createElement("td", null,
                        React.createElement("span", null,
                            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("sso/management/settings/client/tooltip")) },
                                React.createElement(components_1.TableRowIcon, { className: 'black', icon: 'fa-info', circle: true })))),
                    React.createElement("td", null,
                        props.clientListStatus === 'FAILURE' && (React.createElement("div", null, (0, translation_1.getLocalization)("sso/management/settings/client/failure"))),
                        props.clientListStatus === 'FETCHING' && (React.createElement("div", null,
                            React.createElement(sok_ui_1.LoadingSpinner, null))),
                        props.clientListStatus === 'FETCHED' && (React.createElement(sok_ui_1.Dropdown2, null,
                            React.createElement(sok_ui_1.TextInput, { readOnly: true, value: props.state.clientId }),
                            React.createElement(sok_ui_1.Dropdown2Menu, { className: 'sso-management-list-create-client-id' }, props.clientList.map(function (x) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () {
                                    return props.setState(__assign(__assign({}, props.state), { clientId: x.clientId }));
                                } }, x.clientId)); })))))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("label", null,
                            (0, translation_1.getLocalization)("sso/management/settings/visibility"),
                            ":")),
                    React.createElement("td", null,
                        React.createElement("span", null,
                            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("sso/management/settings/visibility/tooltip")) },
                                React.createElement(components_1.TableRowIcon, { className: 'black', icon: 'fa-info', circle: true })))),
                    React.createElement("td", null,
                        React.createElement("div", { className: 'visibility' },
                            React.createElement(sok_ui_1.Input, { type: 'radio', label: (0, translation_1.getLocalization)("sso/management/settings/visibility/hide"), value: props.state.visible === false, onClick: function () {
                                    return props.setState(__assign(__assign({}, props.state), { visible: false }));
                                } }),
                            React.createElement(sok_ui_1.Input, { type: 'radio', label: (0, translation_1.getLocalization)("sso/management/settings/visibility/show"), value: props.state.visible === true, onClick: function () {
                                    return props.setState(__assign(__assign({}, props.state), { visible: true }));
                                } })))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("label", null,
                            (0, translation_1.getLocalization)("sso/management/settings/policy"),
                            ":")),
                    React.createElement("td", null,
                        React.createElement("span", null,
                            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("sso/management/settings/policy/tooltip")) },
                                React.createElement(components_1.TableRowIcon, { className: 'black', icon: 'fa-info', circle: true })))),
                    React.createElement("td", null,
                        React.createElement(sok_ui_1.Dropdown2, null,
                            React.createElement(sok_ui_1.TextInput, { readOnly: true, value: (0, translation_1.getLocalization)("sso/management/settings/policy/".concat(props.state.policy)) }),
                            React.createElement(sok_ui_1.Dropdown2Menu, { className: 'sso-management-list-create-policy' },
                                React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () {
                                        return props.setState(__assign(__assign({}, props.state), { policy: 'SINGLE' }));
                                    } }, (0, translation_1.getLocalization)("sso/management/settings/policy/SINGLE")),
                                React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () {
                                        return props.setState(__assign(__assign({}, props.state), { policy: 'MULTI' }));
                                    } }, (0, translation_1.getLocalization)("sso/management/settings/policy/MULTI")))))))),
        React.createElement(sok_ui_1.Footer, null,
            React.createElement(sok_ui_1.Button, { color: 'green', disabled: props.createStatus === 'FETCHING', text: (0, translation_1.getLocalization)('userfront/button/save'), onClick: function () { return props.create(props.state); } }),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('userfront/button/cancel'), onClick: function () { return props.setIsOpen(false); } }))));
});
function reCalcList(props) {
    var contentWidth = 0;
    // Handle files
    var columns = props.items.reduce(function (p, item) {
        Object.keys(item).forEach(function (c) {
            if (!headers.includes(c))
                return p;
            var dataKey = '__' + c.replace(/-/g, '');
            var text = (function (v, c) {
                return v;
            })((item[c] || '').toString(), c);
            var length = (0, text_1.calculateStringLength)(text);
            var prevValue = p[dataKey];
            if (prevValue && prevValue < length) {
                p[dataKey] = length;
            }
            else if (!prevValue) {
                p[dataKey] = length;
            }
        });
        return p;
    }, {});
    // Override styles for dynamic classes
    var style = document.getElementById('SSOManagementCompanyListCSS');
    if (style && style.parentNode) {
        style.parentNode.removeChild(style);
    }
    style = document.createElement('style');
    style.id = 'SSOManagementCompanyListCSS';
    document.head && document.head.appendChild(style);
    var sheet = style.sheet;
    contentWidth += 13;
    Object.keys(columns).forEach(function (className, i) {
        var colwidth = Math.max(8, 4 + columns[className] + 26); // convert to rem
        contentWidth += colwidth;
        sheet.insertRule(".".concat(className) +
            ' {max-width: ' +
            colwidth +
            'px;\n min-width: ' +
            colwidth +
            'px;}', i);
    });
    if (contentWidth !== props.contentWidth) {
        props.setContentWidth(contentWidth);
    }
}
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.withState)('isOpen', 'setIsOpen', false), (0, recompose_1.withState)('removeIsOpen', 'setRemoveIsOpen', false), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('total', 'setTotal', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.fetch();
        this.props.fetchClients();
        this.props.setItems(this.props.management.list.sort(function (a, b) { return a.name.localeCompare(b.name); }));
        reCalcList(__assign(__assign({}, this.props), { items: this.props.management.list }));
    },
    componentDidUpdate: function (prevProps) {
        if (prevProps.management.listStatus !== 'FETCHING' &&
            this.props.management.listStatus !== prevProps.management.listStatus) {
            this.props.fetch();
        }
        if (prevProps.management.clientListStatus !== 'FETCHING' &&
            this.props.management.clientListStatus !==
                prevProps.management.clientListStatus) {
            this.props.fetchClients();
        }
        if (this.props.management.list !== prevProps.management.list) {
            this.props.setItems(this.props.management.list.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            }));
        }
        if (this.props.items !== prevProps.items) {
            reCalcList(this.props);
        }
    }
}), recompose_1.pure);
function getColumn(column, value) {
    return (React.createElement("div", { className: classNames("row__column dynamic __".concat(column), column === 'name-meta' && 'expand'), "data-key": "__".concat(column) }, value));
}
var NotFoundPlaceHolder = function (props) { return (React.createElement("div", __assign({}, props, { key: 'no-federations', className: 'no-sso-management-federations' }),
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9') }),
    React.createElement("b", null, (0, translation_1.getLocalization)("sso/management/emptyList/title")),
    React.createElement("span", null, (0, translation_1.getLocalization)("sso/management/emptyList/message")))); };
var _createRowData = function (style, items, selectedLanguage, selectedItems, select) { return ({
    style: style,
    items: items,
    selectedLanguage: selectedLanguage,
    selectedItems: selectedItems,
    select: select
}); };
var createRowData = memoize(_createRowData);
var ListRowDataExtractable = Types.extractReturnType(_createRowData);
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var items = data.items, selectedLanguage = data.selectedLanguage, selectedItems = data.selectedItems, select = data.select;
    var row = items[index];
    var selected = selectedItems.find(function (x) { return x.id === row.id; });
    return (React.createElement("div", { className: classNames('row'), style: style },
        React.createElement("div", { className: "row__column narrow" },
            React.createElement(components_1.TableRowIcon, { icon: 'fa-check', circle: true, className: selected ? 'selected' : null, onClick: function (e) {
                    e.stopPropagation();
                    select(row, !selected);
                } })),
        getColumn('id', React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/admin/sso/").concat(row.provider) }, row.id)),
        getColumn('name', React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/admin/sso/").concat(row.provider) }, row.name)),
        React.createElement("div", { className: "row__column narrow" })));
});
var ListHeader = function () {
    return (React.createElement("div", { className: ' header row' },
        React.createElement("div", { className: "row__column narrow" }),
        React.createElement("div", { key: 'id', "data-key": '__id', className: classNames('row__column extends', '__id') }, "ID"),
        React.createElement("div", { key: 'name', "data-key": 'name', className: classNames('row__column extends', '__name') }, "Name")));
};
exports.default = enhance(function (props) {
    var itemData = createRowData({}, props.items, props.selectedLanguage, props.management.listSelected, props.select);
    return (React.createElement("div", { className: 'content-wrapper-content' },
        React.createElement("div", { className: 'sso-management-list-view' },
            React.createElement("main", { className: 'content' },
                React.createElement(sok_ui_1.BreadCrumb, null,
                    React.createElement(react_router_dom_1.Link, { to: "/" }, "SokoPro"),
                    React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/system')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/ssomanagement'))),
                React.createElement("div", { className: 'button-group' },
                    React.createElement(sok_ui_1.Button, { size: 'large', color: 'blue', text: 'Add new federation', onClick: function () { return props.setIsOpen(true); } }),
                    React.createElement(sok_ui_1.Button, { size: 'large', color: 'red', text: 'Delete federation', disabled: props.management.listSelected.length !== 1, onClick: function () { return props.setRemoveIsOpen(true); } }),
                    React.createElement(sok_ui_1.RequestStatusBox, { status: props.management.removeStatus, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILURE'] },
                        React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/removing')),
                        React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/removed')),
                        React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/failed')))),
                React.createElement("div", { key: 'list', className: 'sok-list-content sso-management-list-container' },
                    React.createElement("div", { className: 'sok-list-content sso-management-list ' +
                            props.management.listStatus.toLowerCase() },
                        props.management.listStatus === 'FAILURE' && (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
                            React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () { return props.fetch(); } }))),
                        props.management.listStatus === 'FETCHING' && (React.createElement("div", { key: 'loading', className: 'center' },
                            React.createElement(sok_ui_1.LoadingSpinner, null))),
                        props.management.listStatus === 'FETCHED' && props.items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                            var width = _a.width, height = _a.height;
                            return (React.createElement(sok_ui_1.List, { key: 'list', itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, placeholder: React.createElement(NotFoundPlaceHolder, { key: 'not-found' }), header: React.createElement(ListHeader, null) }, ListRow));
                        })))),
                React.createElement(CreateFederation, { isOpen: props.isOpen, setIsOpen: props.setIsOpen, create: props.create, clientList: props.management.clientList, clientListStatus: props.management.clientListStatus, createStatus: props.management.createStatus, fetch: props.fetch, clearManagementModals: function () { return props.clearManagementModals(); } }),
                React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.removeIsOpen, close: function () { return props.setRemoveIsOpen(false); }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
                        React.createElement(ConfirmDialog_1.Exclamation, null),
                        React.createElement("div", null,
                            React.createElement("div", { className: 'title please-confirm-text' },
                                React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                            React.createElement("div", { className: 'text' },
                                React.createElement("p", null,
                                    "Federation:",
                                    ' ',
                                    props.management.listSelected.length > 0
                                        ? props.management.listSelected[0].provider
                                        : '-')))), footer: React.createElement(React.Fragment, null,
                        React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                                props.remove(props.management.listSelected[0]);
                                props.setRemoveIsOpen(false);
                            } }),
                        React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setRemoveIsOpen(false); } })) })))));
});
